import { Dropdown, Input } from "antd";
import {
  ArrowUpDown,
  CircleX,
  Filter,
  ListFilter,
  Plus,
  Search,
} from "lucide-react";
import React, { useState } from "react";
import BatchTable from "./BatchTable";
import NoActiveBatches from "./NoActiveBatches";

function BatchDetailsSec({
  allBatchData,
  pageCount,
  currentPage,
  onPageChange,
  pageSize,
  getAllBatch,
  setCreateBatchFlag,
  sortItems,
  filterItems,
  setSortBy,
  sortBy,
  setFilter,
  filter,
  setSearchValue,
  searchValue,
  setSearchText,
  searchText,
}) {
  return (
    <>
      <div className="mt-4">
        {!searchValue && allBatchData?.b2BCandidateBatchList?.length === 0 ? (
          <></>
        ) : (
          <div className="flex justify-between mb-3 flex-wrap gap-y-2">
            <div className="flex gap-x-[.65rem] gap-y-2 items-center flex-wrap">
              <div>
                <Input
                  prefix={<Search size={15} />}
                  placeholder="Search batches..."
                  suffix={
                    (searchText || searchValue) && (
                      <button
                        type="button"
                        onClick={() => {
                          setSearchText("");
                          setSearchValue("");
                        }}
                        className="flex items-center justify-center text-gray-500 hover:text-gray-700"
                      >
                        <CircleX size={15} />
                      </button>
                    )
                  }
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onPressEnter={(e) => setSearchValue(e.target.value)}
                />
              </div>

              <Dropdown
                menu={{
                  // items: sortItems,
                  items: filterItems.map((item) => ({
                    ...item,
                    className:
                      filter === item.key
                        ? "!bg-orange-50 !text-[#DC6803] font-semibold"
                        : "",
                  })),
                  selectedKeys: [filter],
                  onClick: ({ key }) => {
                    setFilter(key);
                  },
                }}
                trigger={["click"]}
              >
                <button className="flex gap-x-[6px] font-medium items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
                  <ListFilter size={14} />
                  Filter
                </button>
              </Dropdown>

              <Dropdown
                menu={{
                  // items: sortItems,
                  items: sortItems.map((item) => ({
                    ...item,
                    className:
                      sortBy === item.key
                        ? "!bg-orange-50 !text-[#DC6803] font-semibold"
                        : "",
                  })),
                  selectedKeys: [sortBy],
                  onClick: ({ key }) => {
                    setSortBy(key);
                  },
                }}
                trigger={["click"]}
              >
                <button className="flex gap-x-[6px] font-medium items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
                  <ArrowUpDown size={14} />
                  Sort by
                </button>
              </Dropdown>
            </div>
            <div className="flex gap-x-3 gap-y-2 items-center flex-wrap">
              <button
                onClick={() => setCreateBatchFlag(true)}
                className="btn-orange flex gap-[.3rem] items-center rounded-lg px-3 py-[.35rem] font-medium text-[.82rem]"
              >
                <Plus size={14} color="black" /> Create New Batch
              </button>
            </div>
          </div>
        )}

        {searchValue &&
        (!allBatchData?.b2BCandidateBatchList ||
          allBatchData?.b2BCandidateBatchList?.length === 0) ? (
          <div className="mt-10 mb-4 text-center text-gray-500">
            No search results found.
          </div>
        ) : allBatchData?.b2BCandidateBatchList?.length > 0 ? (
          <BatchTable
            allBatchData={allBatchData}
            pageCount={pageCount}
            currentPage={currentPage}
            onPageChange={onPageChange}
            pageSize={pageSize}
            getAllBatch={getAllBatch}
          />
        ) : (
          <NoActiveBatches setCreateBatchFlag={setCreateBatchFlag} />
        )}
      </div>
    </>
  );
}

export default BatchDetailsSec;
